import { version } from '@algolia/autocomplete-shared';
export var userAgents = [{
  segment: 'autocomplete-js',
  version: version
}];


//////////////////
// WEBPACK FOOTER
// /home/runner/work/medischeartikelen-website/medischeartikelen-website/node_modules/@algolia/autocomplete-js/dist/esm/userAgents.js
// module id = 26
// module chunks = 0